<template>
  <div v-if="error" class="alert alert-danger">
    <h5 class="alert-heading">{{ $t("js.backend.board.error") }}</h5>
    <details>
      <summary v-text="error.message" />
      <pre v-text="error.backtrace.join('\n')" />
    </details>
  </div>
  <div v-else>
    <p>
      <time :datetime="startedAt" v-if="startedAt">{{ $t("js.backend.board.started_time_ago", {
    time_ago:
      startedAgo
  }) }}</time>
      <span v-else>{{ $t("js.backend.board.starting_soon") }}</span>
    </p>
    <div class="progress mb-5">
      <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" :aria-valuemax="total"
        :style="{ width: progressPercentage }">
        {{ `${progress}/${total}` }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import apiClient from "@/entrypoints/frontend/apiClient";

export default defineComponent({
  name: "BoardProgressBar",
  props: {
    electionId: {
      type: Number,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
    initialCount: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 100,
    },
    startedAt: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      progress: this.initialCount,
      reloading: false,
      intervalId: null,
      startedAgo: null,
      error: null,
    }
  },
  computed: {
    progressPercentage() {
      return `${Math.round((this.progress / this.total) * 100)}%`;
    },
    startedAtDateTime() {
      return Date.parse(this.startedAt);
    },
  },
  beforeMount() {
    this.relative_time = new Intl.RelativeTimeFormat(this.$i18n.locale || "da", { numeric: "auto" });
  },
  mounted() {
    this.checkStatus();
    this.updateTimestamp();
    this.intervalId = setInterval(this.checkStatus, 500);
    setInterval(this.updateTimestamp, 1000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {
    updateTimestamp() {
      if (!this.startedAtDateTime) return;
      const value = Math.round((this.startedAtDateTime - Date.now()) / 1000);
      if (Math.abs(value) >= 60) {
        this.startedAgo = this.relative_time.format(Math.floor(value / 60), "minute");
      } else {
        this.startedAgo = this.relative_time.format(value, "second");
      }
    },
    async checkStatus() {
      const response = await apiClient.get(window.location.href);
      this.progress = response.data.publishProgress;
      this.error = response.data.error;

      if (this.progress === null || this.progress === this.total) {
        this.progress = this.total;
        this.reloadPage();
      }
      this.updateTimestamp();
    },
    reloadPage() {
      window.clearInterval(this.intervalId);
      setTimeout(() => window.location.reload(), 500);
    },
  }
});
</script>
